import { observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { StoreStore } from "./StoreStore";

type IProps = RouteComponentProps<{}> & {
    store: StoreStore
};

@observer
export class StoreError extends React.Component<IProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    background: `linear-gradient(${theme.customColors.storeGradientDarkBlue}, ${theme.customColors.storeGradientLightBlue})`,
                    textAlign: "center",
                    paddingLeft: 32,
                    paddingRight: 32
                }}
            >
                <pr.VCenterDiv style={{ height: "100vh", justifyContent: "center" }}>
                    <pr.VFlex>
                        <img
                            src={require("assets/store-error.svg")}
                            style={{
                                marginBottom: theme.MARGIN,
                                width: 80,
                                height: 80,
                                marginLeft: "auto",
                                marginRight: "auto"
                            }}
                        />
                        <pr.P_16_TITLE style={{ color: "white" }}>
                            {ui.__("store.error.couldNotLoad")}
                        </pr.P_16_TITLE>
                    </pr.VFlex>
                </pr.VCenterDiv>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/store/StoreError.tsx